import React from 'react';
import { Carousel } from 'react-bootstrap';

import banner from '../images/image.jpg'
import banner1 from '../images/banner1.jpg';
import banner2 from '../images/banner2.jpg';
import banner3 from '../images/banner3.jpg';


const Carousal = () => {
  return (
    <Carousel fade interval={3500} controls={true} indicators={true} className="custom-carousel">

<Carousel.Item>
        <img className="d-block w-100" src={banner} alt="First slide" />
      </Carousel.Item>


      <Carousel.Item>
        <img className="d-block w-100" src={banner1} alt="First slide" />
      </Carousel.Item>

      <Carousel.Item>
        <img className="d-block w-100" src={banner2} alt="Second slide" />
      
      </Carousel.Item>

      <Carousel.Item>
        <img className="d-block w-100" src={banner3} alt="Third slide" />
      
      </Carousel.Item>
    </Carousel>
  );
};

export default Carousal;
